// store/modules/auth.js
const state = {
    loginData: null,
};

const mutations = {
    setLoginData(state, data) {
        state.loginData = data;
    },
    clearLoginData(state) {
        state.loginData = null;
    },
};

const actions = {
    updateLoginData({ commit }, data) {
        commit("setLoginData", data);
    },
    clearLoginData({ commit }) {
        commit("clearLoginData");
    },
};

const getters = {
    getLoginData: (state) => state.loginData,
    isLoggedIn: (state) => !!state.loginData,  // 判断是否登录
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
